import { deriveServiceMenuData } from "@/lib/derive-service-menu-data"
import type { CatalogSnapshot } from "@/lib/revalidate-checkout-catalog"
import type { ApiData, ServiceType } from "@/types"

/**
 * Channel whose menu an order on `serviceType` is sold from, mirroring `ServiceType.MenuChannel` in
 * merchant-service-core: takeout follows the delivery menu while the store has one, and sells its own
 * menu otherwise.
 */
export function catalogChannelFor(serviceType: ServiceType, deliveryHasMenu: boolean): ServiceType {
  return serviceType === "TAKEOUT" && deliveryHasMenu ? "DELIVERY" : serviceType
}

/**
 * The slice of a fresh catalog an order on `serviceType` may buy from: only the categories and item
 * offers its channel's menu publishes (Service -> Menu -> Category -> ItemOffer). `null` when that
 * channel has no menu, so nothing can be sold on it.
 */
export function channelCatalogSnapshot(data: ApiData, serviceType: ServiceType): CatalogSnapshot | null {
  const deliveryHasMenu = deriveServiceMenuData(data, "DELIVERY") !== null
  const derived = deriveServiceMenuData(data, catalogChannelFor(serviceType, deliveryHasMenu))
  if (!derived) return null
  return {
    categories: derived.categories,
    itemOffers: derived.itemOffers,
    optionGroups: data.optionGroups,
    availabilities: data.availabilities,
    items: data.items,
  }
}
